var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearFormat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H17C17.9665 1.25 18.75 2.0335 18.75 3V6.63636C18.75 6.67714 18.7467 6.71715 18.7405 6.75616C18.2636 6.51754 17.7472 6.45495 17.25 6.52063V3C17.25 2.86193 17.1381 2.75 17 2.75H10.75V12.106L9.25 13.606V2.75H3C2.86193 2.75 2.75 2.86193 2.75 3V6.63636C2.75 7.05058 2.41421 7.38636 2 7.38636C1.58579 7.38636 1.25 7.05058 1.25 6.63636V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5068 8.47053C17.0616 7.91574 17.8861 7.84079 18.3484 8.30311L21.6969 11.6516C22.1592 12.1139 22.0843 12.9384 21.5295 13.4932L16.0617 18.9609L11.0391 13.9383L16.5068 8.47053Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.97839 14.9989L15.0011 20.0216L13.4932 21.5295C12.9384 22.0843 12.1139 22.1592 11.6516 21.6969L8.30311 18.3484C7.84079 17.8861 7.91574 17.0616 8.47053 16.5068L9.97839 14.9989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFormat);
export default __webpack_public_path__ + "static/media/clear-format.3590cd70233288d75e201aa777bc1c85.svg";
export { ForwardRef as ReactComponent };